import * as React from 'react';
import Stack from '@mui/material/Stack';
import LogoutIcon from '@mui/icons-material/Logout';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../mui-theme/ColorModeIconDropdown';

export default function Header({ onLogout }) {
    return (
        <Stack
            direction="row"
            sx={{
                display: {xs: 'none', md: 'flex'},
                width: '100%',
                alignItems: {xs: 'flex-start', md: 'center'},
                justifyContent: 'space-between',
                maxWidth: {sm: '100%', md: '1700px'},
                pt: 1.5,
            }}
            spacing={2}
        >
            <NavbarBreadcrumbs/>
            <Stack direction="row" sx={{gap: 1}}>
                <ColorModeIconDropdown/>
                <MenuButton aria-label="Logout" onClick={onLogout}>
                    <LogoutIcon />
                </MenuButton>
            </Stack>
        </Stack>
    );
}